import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlertManagerService {
  private currentAlerts: HTMLIonAlertElement[] = [];

  push(alert: HTMLIonAlertElement) {
    this.currentAlerts.push(alert);

    // Reset reference when dismissed
    alert.onDidDismiss().then(() => {
      if (this.currentAlerts.length === 0) return;
      const index = this.currentAlerts.indexOf(alert);
      if (index > -1) {
        this.currentAlerts.splice(index, 1);
      }
    });
  }

  async dismissAll() {
    const alertsToDismiss = [...this.currentAlerts];
    this.currentAlerts = [];
    await Promise.all(alertsToDismiss.map((alert) => alert.dismiss()));
  }
}
